import { Autor } from "@/types/administracao/autor/autor";
import { Service } from "../mainService";
import { PortalError } from "@/types/portal-error";

const autorService = {
    getAutores,
    getTipos,
    removeAutor,
    salvarAutor,
}

async function getAutores(page?: number, pageSize?: number, nome?: string, tipo?: number): Promise<Autor[]> {
    try {
        const response = await Service.$http.get(`
                ${process.env.VUE_APP_ENTREGAS_API}/Autor/listar${nome || tipo || page || pageSize ? '?' : ''}${nome ? `filtroNome=${nome}&` : ''}${tipo ? `filtroTipo=${tipo}&` : ''}${page ? `page=${page}&` : ''}${pageSize ? `pageSize=${pageSize}` : ''}
            `)
        return response.data.autores
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function getTipos(): Promise<{ Id: number, Descricao: string }[]> {
    try {
        const response = await Service.$http.get(`
            ${process.env.VUE_APP_ENTREGAS_API}/Autor/tipos
            `)
        return response.data
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function removeAutor(idAutor: number): Promise<any> {
    try {
        const response = await Service.$http.delete(
            `${process.env.VUE_APP_ENTREGAS_API}/Autor/remover/${idAutor}`
        )
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

async function salvarAutor(autor: Autor): Promise<Autor> {
    try {
        autor = new Autor(autor)
        const response = await Service.$http.post(
            `${process.env.VUE_APP_ENTREGAS_API}/Autor/salvar`,
            autor.toFormData()
        )
        return response.data
    } catch (e: any) {
        if (e.response && [400, 401, 403].includes(e.response.status)) {
            const errors: any = [];
            if (e.response.data.errors)
                for (const [key, value] of Object.entries(e.response.data.errors))
                    errors.push(`${key}: ${value}`);
            throw new PortalError(
                e.response.data.erros ?? e.response.data.msg ?? errors
            );
        } else {
            throw e;
        }
    }
}

export default autorService